import { spin } from '../../utils/style';
import styled, { css } from 'styled-components';
import { Format, StyleColor } from '../../utils/styles-constants';
import { NewButton } from '../Button/styles';
import { FormFieldContainer } from '../Share/UprezForm/styles';

interface InfosFieldsProps {
	isActive: boolean;
}

const InfosFields = styled(FormFieldContainer)`
	font-weight: ${(props: InfosFieldsProps) => props.isActive ? '700' : '400'};
	width: calc(100% - 30px);
	padding: 0 15px;
	font-size: 15px;
	letter-spacing: 0.2px;
	justify-content: space-between;
	cursor: pointer;
`;

const ButtonContainer = styled('div')`
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	justify-content: center;
	margin: auto;

	@media ${Format.Smartphone} {
		flex-direction: column;
	}
`;

const ParametersPageButton = styled(NewButton)`
	margin: 35px 15px 0 15px;
	width: auto;
	min-width: 360px;

	@media ${Format.Smartphone} {
		align-self: center;
	}

	@media ${Format.SmartphonePortrait} {
		margin: 25px 0 0;
		width: 100%;
		min-width: auto;
	}
`;

const CancelButton = styled(ParametersPageButton)`${css`
	background-color: ${StyleColor.Grey500};
	border-color: ${StyleColor.Grey500};

	& > span {
		width: 50%;
	}

	& > svg {
		height: 25px;
		width: 25px;
		animation: ${spin};
	}
`}`;

const CheckboxWrapper = styled('div')`
	margin: 20px auto;
`;

export {
	ButtonContainer,
	ParametersPageButton,
	CancelButton,
	InfosFields,
	CheckboxWrapper,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/styles.ts